export default {
    fund: 'الصندوق',
    name: 'الاسم',
    type: {
        title: 'النوع',
        main: 'أساسي',
        sub: 'فرعي',
    },
    category: 'التصنيف',
    'final-account': {
        title: 'الحساب الختامي',
        operations: 'تشغيل',
        trade: 'مُتاجرة',
        'gains-and-losses': 'أرباح وخسائر',
        budget: 'ميزانية',
    },

    set: 'تعيين',
    reset: 'إلغاء التعيين',
    account: 'الحساب',
    save: 'حفظ',

    'default-warehouse': 'المستودع الافتراضي',
    no: 'الرقم',
    notes: 'الملاحظات',
    warehouse: 'المستودع',
    
    'purchasing-account': 'حساب المُشتريات',
    'purchasing-refund-account': 'حساب مرتجع المشتريات',
    'account-trade': 'الحساب (متاجرة)',
    
    'sales-account': 'حساب المبيعات',
    'sales-refund-account': 'حساب مرتجع المبيعات',
    
    'granted-discount-account': 'حساب الحسم الممنوح',
    'account-gains-and-losses-or-trade': 'الحساب (أرباح وخسائر/متاجرة)',
    'account-budget': 'الحساب (ميزانية)',

    'earned-discount-account': 'حساب الحسم المُكتسب',

    'rotate-profit-and-loss': 'حساب مدور أرباح وخسائر',
    'rotate-materials-end-of-term': 'حساب بضاعة آخر المدة',
}